/**
 * The zoom buttons in the detailed view and their functionality
 */
import React from 'react'
import TouchButton from '../../utils/ope-touch-button'
import SelectorActions from '../../../actions/selector-actions'
import AdobeAnalytics from '../../../utils/adobe-analytics'
import touchHandler from './touch-handlers'
import createReactClass from 'create-react-class'


var CropperZoom = createReactClass({
	zoomIn: function() {
		var instance = this.props.instance, item = instance.props.item,
			width = instance.selection.offsetWidth,
			height = instance.selection.offsetHeight,
			selRect = instance.selection.getBoundingClientRect(),
			rectX = selRect.left || selRect.x, rectY = selRect.top || selRect.y,
			scale = item.options.scale + 0.125,
			x = width / 2 + rectX, y = height / 2 + rectY,
			newDPI = item.getDPI(scale);
		// Check the new DPI after the zoom
		if(newDPI > 151) {
			touchHandler.zoomAtPoint(x, y, scale, instance);
		}
		if(newDPI < 300) {
			// If the new DPI is below the recommended DPI for prints then add low res warning
			SelectorActions.setLowResWarning(item.getId());
		}
		if(newDPI > 300 && item.getLowResWarning()) {
			SelectorActions.removeLowResWarning(item.getId());
		}
	},

	zoomOut: function() {
		var instance = this.props.instance,
			item = instance.props.item,
			width = instance.selection.offsetWidth,
			height = instance.selection.offsetHeight,
			scale = item.options.scale - 0.125,
			selRect = instance.selection.getBoundingClientRect(),
			rectX = selRect.left || selRect.x, rectY = selRect.top || selRect.y,
			x = width / 2 + rectX, y = height / 2 + rectY;

		if (scale < 1.0 ) {
			scale = 1.0;
		}

		var newDPI = item.getDPI(scale);
		touchHandler.zoomAtPoint(x, y, scale, instance);

		if(newDPI > 300 && item.getLowResWarning()) {
			SelectorActions.removeLowResWarning(item.getId());
		}
	},

	render: function() {
		return (
			<div className="ope-editor__detailed__zoom">
				<TouchButton className="ope-button ope-button--zoom-in" onTap={this.zoomIn}>
					<div className="ope-icon--zoom-in"></div>
				</TouchButton>

				<TouchButton className="ope-button ope-button--zoom-out" onTap={this.zoomOut}>
					<div className="ope-icon--zoom-out"></div>
				</TouchButton>
			</div>
		);
	}
});

export default CropperZoom;
